import React from "react";

//firma logosu mobilde sağ üst, webde sağ altta görünür
export default function CompanyLogo({ params, isMobile }) {
  const companyLogo = params?.company ? `/${params.company.toLowerCase()}.png` : "/dev.png";

  if (companyLogo === "/dev.png") return null;
  return (
    <div
      style={{
        position: "absolute",
        bottom: isMobile ? null : 5,
        top: isMobile ? 0 : null,
        right: 5,
        fontSize: isMobile ? "8px" : "12px",
        zIndex: 10,
        textAlign: "center",
        color: "#000000",
        fontFamily: "sans-serif",
        opacity: 1,
      }}
    ><img
        src={companyLogo}
        style={{
          height: isMobile ? 35 : 120,
          objectFit: "contain",
          marginBottom: 4,
        }}
      />
    </div>
  );
}
